type EmojiCategory =
  | "all"
  | "symbols"
  | "people"
  | "animals-nature"
  | "food-drink"
  | "activity"
  | "travel-places"
  | "objects"
  | "flags";

const emojisSets: Record<EmojiCategory, { name: string; emojis: string[] }> = {
  all: {
    name: "All",
    emojis: [
      /* Symbols */
      "❤️",
      "💔",
      "💙",
      "💚",
      "💛",
      "🖤",
      "🤍",
      "🤎",
      "✔️",
      "❌",
      "☑️",
      "❗",
      "❓",
      "⚠️",
      "💯",
      "➕",
      "➖",
      "✖️",
      "➗",
      "♻️",
      "⚡",
      "🔥",
      "✨",
      "⭐",
      "⭕",
      "🚫",

      /* People */
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😍",
      "😘",
      "😎",
      "🤓",
      "😐",
      "😑",
      "😬",
      "🙄",
      "😏",
      "😌",
      "🤩",
      "🥳",
      "🤔",
      "😴",
      "😭",
      "😢",
      "😡",
      "🤯",
      "👍",
      "👎",
      "👌",
      "✌️",
      "🤞",
      "🙏",
      "👏",
      "🙌",
      "💪",

      /* Animals & Nature */
      "🐶",
      "🐱",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐯",
      "🦁",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🐔",
      "🐧",
      "🐦",
      "🦆",
      "🦅",
      "🦄",
      "🐝",
      "🦋",
      "🌲",
      "🌳",
      "🌴",
      "🌵",
      "🌸",
      "🌼",
      "🌻",
      "☀️",
      "🌙",
      "⭐",
      "🌈",
      "🌧️",
      "❄️",
      "🌊",

      /* Food & Drink */
      "🍎",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🍒",
      "🍍",
      "🥭",
      "🍐",
      "🍊",
      "🍋",
      "🍑",
      "🥝",
      "🥑",
      "🍔",
      "🍟",
      "🍕",
      "🌭",
      "🥪",
      "🌮",
      "🌯",
      "🍣",
      "🍜",
      "🍰",
      "🧁",
      "🍩",
      "🍪",
      "🍫",
      "☕",
      "🍵",
      "🥤",
      "🍺",
      "🍷",
      "🍸",
      "🍹",
      "🥂",

      /* Activity */
      "⚽",
      "🏀",
      "🏈",
      "⚾",
      "🎾",
      "🏐",
      "🏉",
      "🎮",
      "🎯",
      "🎳",
      "🎲",
      "♟️",
      "🏃",
      "🚴",
      "🏊",
      "🏋️",
      "🧘",
      "🎸",
      "🎹",
      "🥁",
      "🎺",
      "🎤",
      "🏆",
      "🥇",

      /* Travel & Places */
      "🚗",
      "🚕",
      "🚌",
      "🚎",
      "🚓",
      "🚑",
      "🚒",
      "✈️",
      "🚀",
      "🚁",
      "🚤",
      "🛳️",
      "🚢",
      "🏠",
      "🏢",
      "🏬",
      "🏫",
      "🏥",
      "🏰",
      "🗼",
      "🗽",
      "⛩️",
      "🕌",
      "🌍",
      "🌎",
      "🌏",
      "🏖️",
      "🏝️",

      /* Objects */
      "📱",
      "💻",
      "🖥️",
      "⌨️",
      "🖱️",
      "📷",
      "📸",
      "🎥",
      "📹",
      "📚",
      "📖",
      "📝",
      "📄",
      "📂",
      "🔒",
      "🔑",
      "🗝️",
      "💡",
      "🔦",
      "🕯️",
      "🧰",
      "🛠️",
      "🔧",
      "⚙️",
      "📦",
      "💳",
      "💰",
      "🔋",
      "🔌",

      /* Flags */
      "🇮🇳",
      "🇺🇸",
      "🇬🇧",
      "🇨🇦",
      "🇦🇺",
      "🇩🇪",
      "🇫🇷",
      "🇪🇸",
      "🇮🇹",
      "🇯🇵",
      "🇰🇷",
      "🇨🇳",
      "🇧🇷",
      "🇲🇽",
      "🇷🇺",
      "🇿🇦",
      "🇳🇿",
    ],
  },

  symbols: {
    name: "Symbols",
    emojis: [
      "❤️",
      "💔",
      "💙",
      "💚",
      "💛",
      "🖤",
      "🤍",
      "🤎",
      "✔️",
      "❌",
      "☑️",
      "❗",
      "❓",
      "⚠️",
      "💯",
      "➕",
      "➖",
      "✖️",
      "➗",
      "♻️",
      "⚡",
      "🔥",
      "✨",
      "⭐",
      "⭕",
      "🚫",
      "⬆️",
      "⬇️",
      "⬅️",
      "➡️",
      "🔄",
      "🔁",
      "🔀",
      "🔔",
      "🔕",
      "⏰",
      "⌛",
      "⏳",
    ],
  },

  people: {
    name: "People",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😍",
      "😘",
      "😎",
      "🤓",
      "😐",
      "😑",
      "😬",
      "🙄",
      "😏",
      "😌",
      "🤩",
      "🥳",
      "🤔",
      "😴",
      "😭",
      "😢",
      "😡",
      "🤯",
      "👍",
      "👎",
      "👌",
      "✌️",
      "🤞",
      "🙏",
      "👏",
      "🙌",
      "💪",
    ],
  },

  "animals-nature": {
    name: "Animals & Nature",
    emojis: [
      "🐶",
      "🐱",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐯",
      "🦁",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🐔",
      "🐧",
      "🐦",
      "🦆",
      "🦅",
      "🦄",
      "🐝",
      "🦋",
      "🌲",
      "🌳",
      "🌴",
      "🌵",
      "🌸",
      "🌼",
      "🌻",
      "☀️",
      "🌙",
      "⭐",
      "🌈",
      "🌧️",
      "❄️",
      "🌊",
    ],
  },

  "food-drink": {
    name: "Food & Drink",
    emojis: [
      "🍎",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🍒",
      "🍍",
      "🥭",
      "🍐",
      "🍊",
      "🍋",
      "🍑",
      "🥝",
      "🥑",
      "🍔",
      "🍟",
      "🍕",
      "🌭",
      "🥪",
      "🌮",
      "🌯",
      "🍣",
      "🍜",
      "🍰",
      "🧁",
      "🍩",
      "🍪",
      "🍫",
      "☕",
      "🍵",
      "🥤",
      "🍺",
      "🍷",
      "🍸",
      "🍹",
      "🥂",
    ],
  },

  activity: {
    name: "Activity",
    emojis: [
      "⚽",
      "🏀",
      "🏈",
      "⚾",
      "🎾",
      "🏐",
      "🏉",
      "🎮",
      "🎯",
      "🎳",
      "🎲",
      "♟️",
      "🏃",
      "🚴",
      "🏊",
      "🏋️",
      "🧘",
      "🎸",
      "🎹",
      "🥁",
      "🎺",
      "🎤",
      "🏆",
      "🥇",
      "🥈",
      "🥉",
    ],
  },

  "travel-places": {
    name: "Travel & Places",
    emojis: [
      "🚗",
      "🚕",
      "🚌",
      "🚎",
      "🚓",
      "🚑",
      "🚒",
      "✈️",
      "🚀",
      "🚁",
      "🚤",
      "🛳️",
      "🚢",
      "🏠",
      "🏢",
      "🏬",
      "🏫",
      "🏥",
      "🏰",
      "🗼",
      "🗽",
      "⛩️",
      "🕌",
      "🌍",
      "🌎",
      "🌏",
      "🏖️",
      "🏝️",
    ],
  },

  objects: {
    name: "Objects",
    emojis: [
      "📱",
      "💻",
      "🖥️",
      "⌨️",
      "🖱️",
      "📷",
      "📸",
      "🎥",
      "📹",
      "📚",
      "📖",
      "📝",
      "📄",
      "📂",
      "🔒",
      "🔑",
      "🗝️",
      "💡",
      "🔦",
      "🕯️",
      "🧰",
      "🛠️",
      "🔧",
      "⚙️",
      "📦",
      "💳",
      "💰",
      "🔋",
      "🔌",
    ],
  },

  flags: {
    name: "Flags",
    emojis: [
      "🇮🇳",
      "🇺🇸",
      "🇬🇧",
      "🇨🇦",
      "🇦🇺",
      "🇩🇪",
      "🇫🇷",
      "🇪🇸",
      "🇮🇹",
      "🇯🇵",
      "🇰🇷",
      "🇨🇳",
      "🇧🇷",
      "🇲🇽",
      "🇷🇺",
      "🇿🇦",
      "🇳🇿",
    ],
  },
};

const descriptions: Record<string, string> = {
  "💙": "blue heart",
  "💚": "green heart",
  "💛": "yellow heart",
  "🖤": "black heart",
  "🤍": "white heart",
  "🤎": "brown heart",
  "☑️": "check box with check",
  "🔴": "red circle",
  "🟢": "green circle",
  "🟡": "yellow circle",
  "🔵": "blue circle",
  "⬆️": "up arrow",
  "⬇️": "down arrow",
  "⬅️": "left arrow",
  "➡️": "right arrow",
  "🔄": "counterclockwise arrows",
  "🔁": "repeat button",
  "🔀": "shuffle tracks",
  "🔔": "bell",
  "🔕": "muted bell",
  "⏰": "alarm clock",
  "⏳": "hourglass not done",
  "⌛": "hourglass done",
  "♠️": "spade suit",
  "♥️": "heart suit",
  "♦️": "diamond suit",
  "♣️": "club suit",
  "🚫": "prohibited",
  "⭕": "hollow red circle",
  "❎": "cross mark button",

  "😐": "neutral face",
  "😑": "expressionless face",
  "😬": "grimacing face",
  "🙄": "face with rolling eyes",
  "😏": "smirking face",
  "😌": "relieved face",
  "🤩": "star struck",
  "😜": "winking face with tongue",
  "😝": "squinting face with tongue",
  "🤪": "zany face",
  "😢": "crying face",
  "😥": "sad but relieved face",
  "😓": "downcast face with sweat",
  "😱": "face screaming in fear",
  "😨": "fearful face",
  "🤗": "hugging face",
  "🤭": "face with hand over mouth",
  "🤫": "shushing face",
  "🤥": "lying face",
  "👌": "ok hand",
  "✌️": "victory hand",
  "🤞": "crossed fingers",
  "🙌": "raising hands",
  "💪": "flexed biceps",

  "🐔": "chicken",
  "🐧": "penguin",
  "🐦": "bird",
  "🐤": "baby chick",
  "🦆": "duck",
  "🦅": "eagle",
  "🐺": "wolf",
  "🦄": "unicorn",
  "🐝": "honeybee",
  "🐞": "lady beetle",
  "🦋": "butterfly",
  "🐢": "turtle",
  "🐍": "snake",
  "🦖": "t-rex",
  "🌿": "herb",
  "🍀": "four leaf clover",
  "🍁": "maple leaf",
  "🍂": "fallen leaf",
  "🌊": "water wave",
  "❄️": "snowflake",
  "☁️": "cloud",
  "⛈️": "cloud with lightning and rain",
  "🌪️": "tornado",

  "🍐": "pear",
  "🍊": "tangerine",
  "🍋": "lemon",
  "🍑": "peach",
  "🥝": "kiwi fruit",
  "🥑": "avocado",
  "🍆": "eggplant",
  "🌽": "ear of corn",
  "🥕": "carrot",
  "🥔": "potato",
  "🍞": "bread",
  "🥐": "croissant",
  "🥖": "baguette bread",
  "🧀": "cheese wedge",
  "🍖": "meat on bone",
  "🍗": "poultry leg",
  "🥩": "cut of meat",
  "🍦": "soft ice cream",
  "🍨": "ice cream",
  "🍫": "chocolate bar",
  "🍬": "candy",
  "🥛": "glass of milk",
  "🧃": "beverage box",
  "🍹": "tropical drink",
  "🥂": "clinking glasses",

  "🏓": "ping pong",
  "🥊": "boxing glove",
  "🥋": "martial arts uniform",
  "⛳": "flag in hole",
  "🏹": "bow and arrow",
  "🎿": "skis",
  "⛷️": "skier",
  "🏂": "snowboarder",
  "🎤": "microphone",
  "🎬": "clapper board",
  "🎨": "artist palette",
  "🧩": "puzzle piece",
  "🪀": "yo-yo",

  "🚇": "metro",
  "🚉": "station",
  "🚊": "tram",
  "🚝": "monorail",
  "🛻": "pickup truck",
  "🚐": "minibus",
  "🗺️": "world map",
  "🧭": "compass",
  "⛰️": "mountain",
  "🏔️": "snow capped mountain",
  "🌋": "volcano",
  "🏜️": "desert",
  "🏕️": "camping",
  "🏙️": "cityscape",
  "🌆": "city at dusk",
  "🌃": "night with stars",

  "📦": "package",
  "📫": "closed mailbox with raised flag",
  "📬": "open mailbox with raised flag",
  "📭": "open mailbox with lowered flag",
  "🧾": "receipt",
  "💳": "credit card",
  "💰": "money bag",
  "🪙": "coin",
  "🔋": "battery",
  "🔌": "electric plug",
  "🧯": "fire extinguisher",
  "🪜": "ladder",
  "🪞": "mirror",
  "🧹": "broom",
  "🧸": "teddy bear",
};

export { emojisSets, type EmojiCategory, descriptions };
